import { FC, ReactNode, useState } from 'react';
import { Typography } from '@oresundsbron/bridge-ui';
import { Check } from '@oresundsbron/icons';

type SelectorItem = {
  icon: ReactNode;
  text: string;
  id: number;
};

type PrivateSelectorItem = SelectorItem & {
  selected?: number;
  onSelect: Function;
};

type SelectorProps = {
  items: Array<SelectorItem>;
  onChange: Function;
};

const Field: FC<PrivateSelectorItem> = ({
  icon,
  text,
  onSelect,
  selected,
  id,
}) => {
  return (
    <div
      onClick={(e) => onSelect(id)}
      className="flex h-10 flex-row items-center border-t-orange-50 [&:nth-child(n+1)]:border-t-2"
    >
      <div className="flex w-10/12 flex-row items-center justify-start gap-2">
        <div className="flex h-10 w-10 items-center justify-center">{icon}</div>
        <Typography>{text}</Typography>
      </div>
      <div className="flex w-2/12 flex-row items-center justify-center gap-2">
        {selected === id ? <Check></Check> : null}
      </div>
    </div>
  );
};

export const Selector: FC<SelectorProps> = ({ onChange, items }) => {
  const [selected, setSelected] = useState(items[0].id);

  const onSelect = (id: number) => {
    setSelected(id);
    onChange(id);
  };

  return (
    <div className="w-64 cursor-pointer rounded-lg border-2 border-solid md:w-96">
      {items.map((item, i) => (
        <Field
          key={item.id}
          icon={item.icon}
          text={item.text}
          onSelect={onSelect}
          selected={selected}
          id={item.id}
        ></Field>
      ))}
    </div>
  );
};
